<template>
  <div
    class="webzineMagazine__container fullscreen stickActive"
    ref="webzineParent"
    :style="{ '--windowHeight': this.windowHeight + 'px' }"
  >
    <nav class="stickyNavigation__container" ref="stickyNav">
      <ul :class="childStickyClass">
        <li
          v-for="(item, index) in bannerData.slice(0, 8)"
          :class="{ active: `webzine_${index}` === activeElement }"
          :key="index"
        >
          <button
            @keydown.enter="enterscrollToElement('webzine_'.concat(index))"
            @click="clickScrollToElement('webzine_'.concat(index))"
          >
            <strong>{{ '0' + (index + 1) }}</strong>
            <span>{{ item.categoryName }}</span>
          </button>
        </li>
      </ul>
    </nav>

    <div class="webzineCatagory__container" ref="webzineCatagory">
      <section
        v-for="(item, index) in this.bannerData.slice(0, 8)"
        class="webzineCatagory__list"
        :data-id="'webzine_' + index"
        :key="index"
      >
        <div class="webzineCatagory__banner item">
          <picture>
            <source
              :data-srcset="item.mobileImage.src"
              media="(max-width:1023px)"
              srcset="
                data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==
              "
            />

            <img
              class="lazy"
              :data-src="item.desktopImage.src"
              :alt="item.desktopImage.alt"
              src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            />
          </picture>
        </div>

        <div
          class="webzineCatagory__banner-spacer"
          :id="'webzine_'.concat(index)"
          :data-header-color="item.menuColor"
        ></div>

        <div class="webzineCatagory__article item">
          <h2>Article {{ index + 1 }}</h2>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
export default {
  name: 'webzineMagazine',
  props: {
    bannerData: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      childStickyClass: '',
      isScrolledToBottom: false,
      windowHeight: window.innerHeight,
      addActiveNav: false,
      isActive: true,
      activeElement: 'webzine_0',
      inViewport: [],
      scrollY: 0,
    };
  },
  mounted() {
    this.observeListItems();
    this.stickynav();
    window.addEventListener('scroll', this.checkScrollPosition);
    window.addEventListener('resize', this.updateWindowHeight);
    this.headercolorchange();
    this.checkScrollPosition();
    this.clickScrollToElement();
  },

  methods: {
    getListOfCaterody() {
      return this.$refs.webzineCatagory.querySelectorAll(
        '.webzineCatagory__list'
      );
    },
    scallingBanner() {
      const listOfCaterody = this.getListOfCaterody();
      listOfCaterody.forEach((entry) => {
        const webzineBannerSpacer = entry.querySelector(
          '.webzineCatagory__banner-spacer'
        );
        const webzineBanner = entry.querySelector('.webzineCatagory__banner');
        const spacerBottom = webzineBannerSpacer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        const halfWindowHeight = windowHeight / 4;
        if (spacerBottom <= windowHeight && spacerBottom >= halfWindowHeight) {
          const progress =
            (spacerBottom - halfWindowHeight) /
            (windowHeight - halfWindowHeight);

          const scale = 1 + 0.15 * progress;
          webzineBanner.style.transform = `translate3d(0px, 0px, 0px) scale(${scale}, ${scale})`;
        } else {
          webzineBanner.style.transform =
            'translate3d(0px, 0px, 0px) scale(1, 1)';
        }
      });
    },
    headercolorchange() {
      const listOfCaterody = this.getListOfCaterody();
      const bodySelector = document.querySelector('body');
      bodySelector.classList.add(this.bannerData[0].menuColor);
      listOfCaterody.forEach((entry) => {
        const webzineBannerSpacer = entry.querySelector(
          '.webzineCatagory__banner-spacer'
        );

        const getHeaderColor =
          webzineBannerSpacer.getAttribute('data-header-color');
        const webzineBannerSpacerRecbottom =
          webzineBannerSpacer.getBoundingClientRect().bottom;
        if (
          webzineBannerSpacerRecbottom <= innerHeight &&
          webzineBannerSpacerRecbottom >= 60 &&
          getHeaderColor
        ) {
          bodySelector.classList.add(getHeaderColor);
        }
        if (webzineBannerSpacerRecbottom < 59 && getHeaderColor) {
          bodySelector.classList.remove('white');
          bodySelector.classList.remove('black');
        }
      });
    },
    horizontalNavScroll() {
      const getNavEl = this.$refs.stickyNav;
      const smallScreen = window.matchMedia('(max-width: 1023px)').matches;
      setTimeout(() => {
        if (getNavEl && smallScreen) {
          return getNavEl?.querySelector('ul > li.active').scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });
        }
      }, 200);
    },
    stickynav() {
      const rectListItem = this.$refs.webzineCatagory.getBoundingClientRect();
      const webzineParent = this.$refs.webzineParent;

      if (rectListItem.bottom >= window.innerHeight || rectListItem.top >= 0) {
        webzineParent.classList.add('stickActive');
        webzineParent.classList.remove('stickInActive');
      } else {
        webzineParent.classList.remove('stickActive');
        webzineParent.classList.add('stickInActive');
      }
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight;
      this.horizontalNavScroll();
    },
    enterscrollToElement(index) {
      setTimeout(() => {
        this.smoothScroll(index);
      }, 150);
    },
    clickScrollToElement(index) {
      this.smoothScroll(index);
    },
    smoothScroll(index) {
      const listOfCaterody = this.getListOfCaterody();
      listOfCaterody.forEach((entry) => {
        var getCategoryattr = entry.getAttribute('data-id');

        if (index === getCategoryattr) {
          const genId = '#'.concat(getCategoryattr);
          VueScrollTo.scrollTo(genId, {
            duration: 800, // Duration of the scroll
            easing: 'easeInOutCubic', // Easing function
          });
        }
      });
    },

    checkScrollPosition() {
      const listOfCaterody = this.getListOfCaterody();
      listOfCaterody.forEach((entry) => {
        const articleBanner = entry.querySelector('.webzineCatagory__article');
        const articleBannerRect = articleBanner.getBoundingClientRect().top;
        if (articleBannerRect <= 0) {
          entry.classList.add('articleTop');
        } else {
          entry.classList.remove('articleTop');
        }
      });

      setTimeout(() => {
        const getActiveElement =
          this.$refs.webzineCatagory.querySelector('.in-viewport');
        if (getActiveElement) {
          const getDataId = getActiveElement.getAttribute('data-id');
          this.activeElement = getDataId;
        }
      }, 100);

      this.stickynav();
      this.horizontalNavScroll();
      this.headercolorchange();
      this.scallingBanner();
    },

    observeListItems() {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-viewport');
              entry.target.classList.remove('out-viewport');
            } else {
              entry.target.classList.remove('in-viewport');
              entry.target.classList.add('out-viewport');
            }
          });
        },
        {
          threshold: 0.001,
        }
      );

      this.$refs.webzineCatagory
        .querySelectorAll('.webzineCatagory__list')

        .forEach((item) => {
          observer.observe(item);
        });
    },
  },

  destroyed() {
    window.removeEventListener('scroll', this.checkScrollPosition);
    window.removeEventListener('resize', this.updateWindowHeight);
  },
};
</script>
